<template>
  <div id="panelDeCamaras_div">
    <!--  REPRODUCCIÓN DE VIDEOS YA GRABADOS  -->
    <div id="cams-manage"> 
      <div class="cam col-12">
        <!-- <button @click="audiocontrol(Camara.CamaraId)" class="audio">
          <i v-if="!Camara.Audio" class="fas fa-volume-mute"></i>
          <i v-else class="fas fa-volume-up"></i>
        </button>         -->
        <video v-bind:id="'video_sesion' + parametros.SesionDeLaAudienciaId" :controls='false' :playsinline='true' preload="auto" :poster='require("@/../src/assets/logo-pj-transparente-blanco.png")'>
          <!--<source :src="videoFile" type="video/webm" /> -->
          <source :src="videoFile" type="video/mp4" />
          HTML5 El vídeo no es soportado por le navegador, porfavor intenta con Google Chrome
        </video>   
      </div>    
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'


  export default {
    data() {
      return {
        enumeraciones,
        rutaDeVideo: "",
        pantallaCompletaActivado: false,
        videoFile: null
      }
    },
    components: {

    },
    props: {
      parametros: Object
    },
    methods: {            
      audiocontrol(camaraId) {
        var video = document.getElementById('camara' + camaraId);
        video.muted = !video.muted;
        element.Audio = !element.Audio;
            Vue.set(this.Camaras, index, element);            
      },      
      cargaVideo: function () {   //debugger
        
        // this.rutaDeVideo = "https://www.w3schools.com/tags/movie.mp4";
        comun.SeEstaCargandoInformacion(true);
          //console.log(this.parametros.RutasDeVideos[0].Ruta);
          const ObtenerVideo = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${(this.parametros.RutasDeVideos[0].RutaEnServidor!= null ? this.parametros.RutasDeVideos[0].RutaEnServidor : this.parametros.RutasDeVideos[0].Ruta)}`;
            try {
                    axios.get(ObtenerVideo, { responseType: 'blob' })
                    .then(respuesta => {  
                      this.videoFile = URL.createObjectURL(new Blob([respuesta.data], {type: 'video/mp4'}))
                      var videoPlayer =document.getElementById('video_sesion' + this.parametros.SesionDeLaAudienciaId);
                      videoPlayer.src = this.videoFile;
                      videoPlayer.load();
                      comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                      comun.SeEstaCargandoInformacion(false);
                                console.log(excepcion);
                                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                    })
              }
              catch(exeption) {
                      comun.SeEstaCargandoInformacion(false);
                      console.log(exeption);
              }
        
      },
    },
    created() {
      this.videoFile = null;
      if (this.parametros.Sala != null && this.parametros.Sala != undefined)
        this.cargaVideo();
    }
  }
</script>
<style scoped>
  #cams-manage {
    display: flex;
    flex-wrap: wrap;
  }

  .cam video {
    width: 100%;
    height: 100%;
  }

  .cam {
    padding: 0;
    background-color: #000;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 4em;
    border: 4px solid #323335;
  }


  button {
    cursor: pointer;
  }

  .audio {
    position: absolute;
    font-size: 16px;
    top: 8px;
    right: 10px;
    background-color: #000;
    color: #FFF;
    border: none;
    z-index: 2;
  }

  .size {
    position: absolute;
    font-size: 16px;
    top: 40px;
    right: 10px;
    background-color: #000;
    color: #FFF;
    border: none;
    z-index: 2;
  }

  .pantaCompleta {
    height: 100% !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/PanelDeReproduccion.vue